module.exports = __webpack_public_path__ + "static/img/009.640f493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/009.png
// module id = HBU+
// module chunks = 1